import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  ViewContainerRef,
  HostListener,
  HostBinding,
} from '@angular/core';
import { CustomModalConfig } from './modal-config';
import { CustomModalRef } from './modal-ref';
import { CustomModalService } from './modal.service';

@Component({
  selector: 'custom-modal-container',
  template: `
    <div class="contents" #portalHost></div>
    <button
      [hidden]="fullscreenClose"
      class="icon close-btn"
      aria-label="Close"
      (click)="onClose()"
    >
      <img src="/assets/icons/close.svg" />
    </button>
  `,
  styles: [
    `
      :host {
        position: relative;
        display: flex;
        flex-direction: column;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 10px 25px rgba(0, 0, 0, 0.15);
        overflow: auto;
        padding: 24px;
        overflow-x: hidden;
        overflow-y: auto;
      }

      .contents {
        padding: 0rem;
        overflow-x: hidden;
        overflow-y: auto;
      }

      .close-btn {
        position: absolute;
        top: 25px;
        right: 25px;
        font-size: 1.5rem;
        border: none;
        background: transparent;
        cursor: pointer;
      }

      .close-btn:hover {
        opacity: 0.9;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class CustomModalContainerComponent {
  config!: CustomModalConfig;
  modalRef!: CustomModalRef<any>;

  fullscreenClose: boolean;

  constructor(public customModalService: CustomModalService) {}

  @ViewChild('portalHost', { read: ViewContainerRef, static: true })
  portalHost!: ViewContainerRef;

  @HostBinding('style.max-height') get _maxHeight() {
    return this.config?.maxHeight ?? null;
  }
  @HostBinding('style.max-width') get _maxWidth() {
    return this.config?.maxWidth ?? null;
  }

  attachComponentPortal(view: any): void {
    this.portalHost.insert(view);
    if (this.config?.panelClass == 'fullscreen-modal') {
      this.fullscreenClose = true;
    } else {
      this.fullscreenClose = false;
    }
  }

  onClose(): void {
    if (!this.config.disableClose) {
      this.modalRef.close();
    }
  }

  // Prevent accidental bubbling clicks on backdrop
  @HostListener('click', ['$event.stopPropagation()'])
  _stopClickPropagation() {}
}
